// web-vitals v5 API (onCLS/onINP/onLCP/onFCP/onTTFB). The old v3 names
// (getCLS/getFID/...) were removed in v5 — getFID no longer exists (replaced
// by INP), so the previous file would have thrown if ever wired up.
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals) => {
      const { onCLS, onINP, onFCP, onLCP, onTTFB } = webVitals;
      onCLS && onCLS(onPerfEntry);
      onINP && onINP(onPerfEntry);
      onFCP && onFCP(onPerfEntry);
      onLCP && onLCP(onPerfEntry);
      onTTFB && onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
